import { Hub } from '@sentry/types'
import { FedopsLogger, PhasesConfig } from '@wix/fedops-logger'
import { RendererTypeCode } from '@wix/thunderbolt-ssr-api'
import { ViewerModel } from '../../types'
import { Factory } from '@wix/web-bi-logger/dist/src/logger'

export type NumericBoolean = 0 | 1 | -999 // -999 is a placeholder for not-supported data

export enum BeatEventType {
	START = 1,
	VISIBLE = 2,
	VIEWER_FINISH = 3,
	PAGE_FINISH = 33,
	FIRST_CDN_RESPONSE = 4,
	TBD = -1,
}

export type ReportBI = (eventName: string, eventPhase?: string) => void
export type SendBeat = (
	eventType: BeatEventType,
	eventName: string,
	options?: { pageId?: string; pageNumber?: number }
) => void

type WixBiSessionBase = {
	initialTimestamp: number
	requestId: string
	viewerSessionId: string
	sessionId: string
	msId: string
	siteMemberId?: string
	initialRequestTimestamp: number
	visitorId?: string
	is_rollout: RendererTypeCode
	is_platform_loaded: NumericBoolean
	suppressbi: boolean
	dc: string
	requestUrl: string
	siteRevision: string
	siteCacheRevision: string
	checkVisibility: () => boolean
	isMesh: NumericBoolean
	isServerSide: NumericBoolean
	st: 0 | 1 | 2 | 3
	isjp: boolean
	commonConfig: ViewerModel['commonConfig']
}

export type CookieAnalysis = { isCached: boolean; caching: string; microPop?: string }

export type WixBiSession = WixBiSessionBase & CookieAnalysis

export type BiStore = {
	msid: WixBiSession['msId']
	initialTimestamp: WixBiSession['initialTimestamp']
	visitorId: WixBiSession['siteMemberId']
	siteMemberId?: WixBiSession['siteMemberId']
	viewerSessionId: WixBiSession['viewerSessionId']
	requestId: WixBiSession['requestId']
	dc: WixBiSession['dc']
	is_rollout: WixBiSession['is_rollout']
	isCached: WixBiSession['isCached'] // TODO @Shahaf what's going on with all this snake case vs. camel case?
	is_headless: boolean
}

export type FedopsStore = {
	msid: string
	sessionId: string
	viewerSessionId: string
	requestId: string
	dc: string
	is_rollout: boolean | null
	is_dac_rollout?: number
	is_sav_rollout?: number
	isCached: boolean | null
	is_headless: boolean
	siteMemberId?: string
}

export type FedopsConfig = {
	biLoggerFactory: Factory
	customParams?: { [paramName: string]: string | boolean }
	phasesConfig?: PhasesConfig
	presetType?: string
	appName?: string
}

export type LoggerIntegrations = {
	fedopsCreator: (biStore: any) => FedopsLogger
	sentryInstance: Hub
	wixBiSession: WixBiSession
	viewerModel: ViewerModel
}

export type LoggerServerIntegrations = {
	fedopsCreator: (biStore: any) => FedopsLogger
	sentryInstance: Hub
}

export type MuteFunc = () => boolean
